import { Box, Text } from '@wix/design-system';
import { EllipsisForTrans, getSearchParams } from '@wix/package-picker-shared';
import { Dismiss } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useShowsMonthlyUpsellNote } from '../../hooks/useShowsMonthlyUpsellNote';
import { LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_DESKTOP, LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_MOBILE, MONTHLY_EXCLUSION_ICON_COLOR } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import s from './CycleSelectorDisabledFeatures.scss';
const LEGACY_TITLE_KEY = 'cycle_entry.monthly_disclaimer.note';
const UPSELL_TITLE_KEY = 'cycle_entry.monthly_disclaimer.note_redesign';
const BETTER_RATES_KEY = 'cycle_entry.monthly_disclaimer.better_rates';
export const MonthlyExclusionsList = _ref => {
  let {
    productId,
    mobile
  } = _ref;
  const module = useCurrentModule();
  const {
    domainName
  } = getSearchParams();
  const {
    Trans
  } = module.internals.useTranslations();
  const showsUpsellNote = useShowsMonthlyUpsellNote();
  const {
    data
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchMonthlyDisabledFeatures({
    productId
  }, Boolean(productId));
  const disabledFeatureKeys = ((data == null ? void 0 : data.disabledFeatures) ?? []).map(feature => {
    var _feature$content;
    return (_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey;
  });
  const exclusionKeys = showsUpsellNote ? [...disabledFeatureKeys.filter(translationKey => Boolean(translationKey)), BETTER_RATES_KEY] : disabledFeatureKeys;
  const legacyIconColor = mobile ? LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_MOBILE : LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_DESKTOP;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    dataHook: "title-wrapper",
    className: mobile || showsUpsellNote ? undefined : s.noteWrapper
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: showsUpsellNote ? UPSELL_TITLE_KEY : LEGACY_TITLE_KEY,
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    })]
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: mobile ? 'SP2' : 'SP1'
  }, exclusionKeys.map((exclusionKey, index) => /*#__PURE__*/React.createElement(Box, {
    key: exclusionKey ?? index,
    dataHook: "monthly-exclusion",
    direction: "horizontal",
    verticalAlign: "middle",
    gap: mobile ? 'SP1' : 'SP2'
  }, /*#__PURE__*/React.createElement(Dismiss, {
    color: showsUpsellNote ? MONTHLY_EXCLUSION_ICON_COLOR : legacyIconColor,
    size: mobile ? '18px' : '20px'
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: exclusionKey,
    values: {
      domainName
    },
    components: {
      ellipsis: /*#__PURE__*/React.createElement(EllipsisForTrans, {
        maxWidth: 160
      })
    }
  }))))));
};
//# sourceMappingURL=MonthlyExclusionsList.js.map